import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
  IAPI_CON006_Request,
  IAPI_CON006_Response,
} from "../../../type/apiType";

// 社会福祉施設等及び特定介護保険施設等の経営者でなくなった者の届参照
const httpAPI_CON006 = async (
  param: IAPI_CON006_Request
): Promise<IAPI_CON006_Response> => {
  let res = await http.post(ApiUrl.API_CON006, {
    ...param,
  });

  return res.data;
};

// 申請状況更新
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

export { httpAPI_CON006, httpAPI_APP016 };
